// extracted by mini-css-extract-plugin
export default {"container":"rVVljjRTDXQCf2sjPuk1","ver":"M2fCTalCwqp31e5kxfGO","placeHolderShimmer":"w60mPjYupYyuBFtzhm8e"};